export default {
  'Submit': 'Submit',
  'Reset': 'Reset',
  'Delete': 'Delete',
  'Are you sure you want to delete this item?': 'Are you sure you want to delete this item?',
  'No results': 'No results',
  'Close': 'Close',
  'Cancel': 'Cancel',
  'Updated': 'Updated',
  'Field': 'Field',
  'Value': 'Value',
  'Filters': 'Filters',
  'Filter': 'Filter',
  'Data unavailable': 'Data unavailable',
  'Loading...': 'Loading...',
  'Deleted': 'Deleted',
  'Please, insert a value bigger than zero!': 'Please, insert a value bigger than zero!',
  'Please type something': 'Please type something',
  'Field is required': 'Field is required',
  'Records per page:': 'Records per page:',
  'start': 'Start',
  'end': 'End',
  'autoInvoiceStatus': 'RoI',
  'attendanceListTemplate': 'Attendance List Template',
  'attendanceListTemplate_INHOUSE_CASE_EMO_TRANS': 'EMO-Trans',
  'attendanceListTemplate_DEFAULT': 'Default',
};
